//import React, { useEffect, useState} from 'react';
import GlobalData from '../../../tools/GlobalData';
import {
	isMobile, isTablet, isDesktop, isSmartTv, isWearable,
	isAndroid, isIOS, isChrome, isFireFox, isSafari,
	isOpera, isIE, isMobileSafari, isSamsungBrowser,
	deviceDetect} from 'react-device-detect';
	//import {isMobile, deviceDetect} from 'react-device-detect';
import UserService from '../../../services/user.service';

	//nu merge (desktop si mobile) = l1=127.0.0.1-l2=127.0.0.1-l3=127.0.0.1
		//const localIpUrl = require('local-ip-url');
	//nu merge = UNDEFINED
		//const internalIp = require('internal-ip');
const publicIp = require('public-ip');

function console_log( ...args){
	GlobalData.Console_log( ...args);
}
function get_mobile_info(){
	let info = "";
	if (isMobile)
		info += "-mobile=yes";
	if (isTablet)
		info += "-tablet=yes";
	if (isDesktop)
		info += "-desk=yes";
	if (isAndroid)
		info += "-andr=yes";
	if (isIOS)
		info += "-ios=yes";
	if (isChrome)
		info += "-chrome=yes";
	if (isSafari)
		info += "-saf=yes";
	if (isMobileSafari)
		info += "-m_saf=yes";
	if (isSamsungBrowser)
		info += "-sam=yes";
	if (isSmartTv)
		info += "-sTv=yes";
	if (isWearable)
		info += "-wear=yes";
	if (isFireFox)
		info += "-ffx=yes";
	if (isOpera)
		info += "-opr=yes";
	if (isIE)
		info += "-ie=yes";
	return info;
/*
	if (is)
		info += "-=yes";
	isMobile, isTablet, isDesktop, isSmartTv, isWearable,
	isAndroid, isIOS, isChrome, isFireFox, isSafari,
	isOpera, isIE, isMobileSafari, isSamsungBrowser,
*/
}

const Videnda_AI_unique_browser_id = 'Videnda_AI_unique_browser_id';
//export
//const UserAnalytics = () => {
class UserAnalytics {
	static static_device = null;
	static static_geo_location = null;
	static public_ip = null;

	static static_device_str = null;
	static static_geo_location_str = null;
	static static_unique_key = null;
	static static_unique_browser_id = null;

	constructor(){
		console_log( "UserAnalytics START");
		//alert("This app use cookies for usage analytics - see details in menu {Site Map} on link {Cookies ...}");
		//this.state = {
		//	device: null,
		//	geo_location: null,
		//}
		this.read_device();
	}
	//const [device, setDevice] = useState( null);
	//const [geoLocation, setGeoLocation] = useState( null);
	//const [status, setStatus] = useState( null);
	/*
		useEffect(() => {
			console_log( "UserAnalytics USEEFFECT", device);
			try{
				user_analytics();
			}catch( err){
				console_log( "UserAnalytics USEEFFECT ERROR", err.message);
			}
		}, []);
	*/
	event( from, tip = "video", info = "-"){
				//HARD localStorage.setItem( Videnda_AI_unique_browser_id, 15);//hardcoded a BUG
				//HARD this.static_unique_browser_id = 15;
				//HARD localStorage.removeItem( Videnda_AI_unique_browser_id);//HARDcoded
		this.read_device();
		let short_info = false;
		if( this.static_unique_browser_id && this.static_unique_browser_id.length > 0){
			short_info = true;
			console_log( "UserAnalytics EVENT_CALL OK", from, this.static_unique_browser_id);
		}else{
			console_log( "UserAnalytics EVENT_CALL ERR", from, this.static_unique_browser_id);
		}
		//let tip = "video";
		//let info = "video_id = NotSent";
		console_log( "UserAnalytics EVENT_CALL POST", from, this.static_unique_browser_id);

		let unique_browser_id = -1;
		if( this.static_unique_browser_id)
			unique_browser_id = this.static_unique_browser_id
		UserService.postUserAnalyticsEvent(
				unique_browser_id,
				short_info ? "" : this.static_geo_location_str, //this first as it is shorter
				short_info ? "" : this.static_device_str, //!!! strings limited at size 257 so send 2
				from,
				tip, //type = video, playlist, blog, category, menu
				info,
			)
			.then(response => {
				console_log("UserAnalytics postUserAnalyticsEVENT RECEIVED", response);
				if( response.data.id){
					//CRAZY this.static_unique_browser_id = response.data.id;
					console_log("UserAnalytics getUserAnalyticsId ID A1", response.data.id, from);
					//CRAZY localStorage.setItem( Videnda_AI_unique_browser_id, this.static_unique_browser_id);
				}
				if( response.data.err_message){
					console_log("UserAnalytics postUserAnalyticsEVENT ERR A", response.data.err_message);
				}
			})
			.catch(err => {
				GlobalData.console_log_err("UserAnalytics postUserAnalyticsEVENT ERR B", err.message);
			});

		/*
		let operation = "";
		if( this.static_device != null){ //this.state.device != null){
			operation += "+device_exists";
			operation += "+Browser=" + this.static_device.browserFullVersion;
			//operation += "+Browser=" + this.state.device.browserFullVersion;
		}
		if( this.static_geo_location){
			operation += "+geo_location_exists";
			operation += "+IPv4=" + this.static_geo_location.IPv4;
		}
		console_log( "UserAnalytics EVENT", from, operation);
		*/
	}

	read_device(){
		if( this.static_unique_browser_id && this.static_unique_browser_id.length > 0){
			console_log( "UserAnalytics QUICK ID", this.static_unique_browser_id);
			return;
		}
		let ubi = localStorage.getItem( Videnda_AI_unique_browser_id);
		if( ubi && ubi.length > 0){
			this.static_unique_browser_id = ubi;
			console_log( "UserAnalytics QUICK LOCAL STORAGE ID", this.static_unique_browser_id);
			return;
		}

		let operation = "";
		if( this.static_device && this.static_device != null){ //this.state.device != null){
			operation += "+device_exists";
		}else{
			this.static_device = deviceDetect();
			//let device_detect = deviceDetect();
			//this.state.device = device_detect;
				//this.setState({ count: this.state.count + 1 }
				//setDevice( device_detect);
			operation += "+read_device";
			console_log( "UserAnalytics ANALYTICS DEVICE", this.static_device);
		}

		if( this.static_geo_location && this.static_geo_location != null){
			operation += "+geo_location_exists";
		}else{
			fetch(`https://geolocation-db.com/json/`)
			.then(res => res.json())
			.then(data=> {
				this.static_geo_location = data;
					//setGeoLocation( data);
				operation += "+read_geo_location";
				console_log( "UserAnalytics ANALYTICS GEO", data);
				console_log( "UserAnalytics STATUS operation THEN", operation);

				this.create_user_unique_id(); //usualy this has both data
			})
			.catch(err => {
				GlobalData.console_log_err("UserAnalytics NO Internet for geolocation", err.message);
			});
		}
		console_log( "UserAnalytics STATUS operation END", operation);

		this.create_user_unique_id(); //usualy this has only device data

		if( !this.public_ip || this.public_ip == null){
			console_log("UserAnalytics getUserAnalyticsId ASYNC START", this.static_geo_location_str);
			(async () => {
				try{
					this.public_ip = await publicIp.v4();
					console_log("UserAnalytics getUserAnalyticsId ASYNC END", this.public_ip);
				}catch( err){
					console_log("UserAnalytics getUserAnalyticsId ASYNC ERROR", err.message);
				}
				//this.static_geo_location_str += "-l5=" + local_ip;
				//console_log(await internalIp.v6());
				//=> 'fe80::1'
				//console_log(await internalIp.v4());
				//=> '10.0.0.79'
			})();
		}
		this.create_user_unique_id(); //usualy this has only device data



		//setStatus( operation);
		//only IP
			// https://api.ipify.org?format=json
		//all
			// https://stackoverflow.com/questions/49257729/retrieving-the-client-request-ip-address
	}

	create_user_unique_id(){
		console_log("UserAnalytics create_user_unique_id START", this.public_ip);
		//alert("This app use cookies for usage analytics - see details in menu {Site Map} on link {Cookies ...}");
		if( ! this.static_device ||
				this.static_device == null ||
			! this.static_geo_location ||
				this.static_geo_location == null){
			GlobalData.console_log_err( "UserAnalytics create_user_unique_id ERR, data not ready",
				this.static_device, this.static_geo_location);
			return;
		}
		if( !this.static_device_str || this.static_device_str == null){
			this.static_device_str = "d=";//mobile may be only this
			if( this.static_device.browserFullVersion != null)
				this.static_device_str += "-bfv=" + this.static_device.browserFullVersion;
			if( this.static_device.browserMajorVersion != null)
				this.static_device_str += "-bmv=" + this.static_device.browserMajorVersion;
			if( this.static_device.browserName != null)
				this.static_device_str += "-bn=" + this.static_device.browserName;
			if( this.static_device.engineName != null)
				this.static_device_str += "-en=" + this.static_device.engineName;
			if( this.static_device.engineVersion != null)
				this.static_device_str += "-ev=" + this.static_device.engineVersion;
			if( this.static_device.isBrowser != null)
				this.static_device_str += "-bw=" + this.static_device.isBrowser;
			if( this.static_device.osName != null)
				this.static_device_str += "-on=" + this.static_device.osName;
			if( this.static_device.osVersion != null)
				this.static_device_str += "-ov=" + this.static_device.osVersion;
			if( this.static_device.userAgent != null)
				this.static_device_str += "-ua=" + this.static_device.userAgent;
		}
		console_log( "UserAnalytics create_user_unique_id DEVICE_STR", this.static_device_str);

		if( !this.static_geo_location_str || this.static_geo_location_str == null){
			this.static_geo_location_str =
				  "ip4=" + this.static_geo_location.IPv4
				+ "-cc=" + this.static_geo_location.country_code
				+ "-cn=" + this.static_geo_location.country_name
				+ "-la=" + this.static_geo_location.latitude
				+ "-lo=" + this.static_geo_location.longitude
				;
				if( this.static_geo_location.city != null)
					this.static_geo_location_str += "-ct=" + this.static_geo_location.city;
				if( this.static_geo_location.postal != null)
					this.static_geo_location_str += "-po=" + this.static_geo_location.postal;
				if( this.static_geo_location.state != null)
					this.static_geo_location_str += "-st=" + this.static_geo_location.state;
/*
	console_log("UserAnalytics getUserAnalyticsId ASYNC START", this.static_geo_location_str);
	(async () => {
		let local_ip = await internalIp.v4();
		this.static_geo_location_str += "-l4=" + local_ip;
		console_log("UserAnalytics getUserAnalyticsId ASYNC END", local_ip, this.static_geo_location_str);
		//console_log(await internalIp.v6());
		//=> 'fe80::1'
		//console_log(await internalIp.v4());
		//=> '10.0.0.79'
	})();

	this.static_geo_location_str += "-l0=" + internalIp.v4.sync();
	//this.static_geo_location_str += "-l3=" + localIpUrl();
	//this.static_geo_location_str += "-l1=" + localIpUrl('public');
	//this.static_geo_location_str += "-l2=" + localIpUrl('private');

	localIpUrl() // => 192.168.31.69
	localIpUrl('public') // => 192.168.31.69
	localIpUrl('public', 'ipv4') // => 192.168.31.69
	localIpUrl('public', 'ipv6') // => fe80::c434:2eff:fe06:f90
	localIpUrl('private') // => 127.0.0.1
	localIpUrl('private', 'ipv4') // => 127.0.0.1
	localIpUrl('private', 'ipv6') // => fe80::1
*/
			console_log( "UserAnalytics create_user_unique_id GEO_compute", this.static_geo_location_str);
		}

		//if both are OK
		//if( !this.static_unique_key || this.static_unique_key == null){
			if( this.static_device_str && this.static_device_str != null
				&& this.static_geo_location_str && this.static_geo_location_str != null
				//MOBILE may be null && this.public_ip && this.public_ip != null
				){

				//const cut = 300;
				//let small_str = this.static_unique_key.substring( 0, cut);
				//UserService.getUserAnalyticsId( small_str)
				UserService.getUserAnalyticsId(
						this.static_geo_location_str
							+ "-l7=" + this.public_ip //this first as it is shorter
							+ "-info=" + get_mobile_info(),
						this.static_device_str //!!! strings limited at size 257 so send 2
					)
					.then(response => {
						console_log("UserAnalytics getUserAnalyticsId RECEIVED", response);
						if( response.data.id){
							this.static_unique_browser_id = response.data.id;
							console_log("UserAnalytics getUserAnalyticsId ID A2", this.static_unique_browser_id);
							localStorage.setItem( Videnda_AI_unique_browser_id, this.static_unique_browser_id);
						}
						if( response.data.err_message){
							console_log("UserAnalytics getUserAnalyticsId ERR A", response.data.err_message);
						}
					})
					.catch(err => {
						GlobalData.console_log_err("UserAnalytics getUserAnalyticsId ERR B", err.message);
					});
			}
		//}

	}
}


/*
					this.static_unique_key =
						this.static_geo_location_str
						+ "-geo-"
						+ this.static_device_str //last for user_agent strange value
						;
				console_log( "UserAnalytics create_user_unique_id UNIQUE_KEY_compute",
					this.static_unique_key);
geo location
IPv4: "46.97.176.67"
city: null
country_code: "RO"
country_name: "Romania"
latitude: 46
longitude: 25
postal: null
state: null

device
browserFullVersion: "90.0.4430.212"
browserMajorVersion: "90"
browserName: "Chrome"
engineName: "Blink"
engineVersion: "90.0.4430.212"
isBrowser: true
osName: "Windows"
osVersion: "10"
userAgent: "Mozilla/5.0 (Windows NT

this.static_device_str =
	  "ip4=" + this.static_device.IPv4
	+ "-ct=" + this.static_device.city
	+ "-cc=" + this.static_device.country_code
	+ "-cn=" + this.static_device.country_name
	+ "-la=" + this.static_device.latitude
	+ "-lo=" + this.static_device.longitude
	+ "-po=" + this.static_device.postal
	+ "-st=" + this.static_device.state
	;

export default {
	user_analytics,
};

			if( !this.static_device_str || this.static_device_str == null){
				this.static_device_str =
					  "brf=" + this.static_device.browserFullVersion
					+ "-bmv=" + this.static_device.browserMajorVersion
					+ "-bn=" + this.static_device.browserName
					+ "-en=" + this.static_device.engineName
					+ "-ev=" + this.static_device.engineVersion
					+ "-isb=" + this.static_device.isBrowser
					+ "-osn=" + this.static_device.osName
					+ "-osa=" + this.static_device.osAgent
					+ "-ua=" + this.static_device.userAgent
					;
				console_log( "UserAnalytics DEVICE_STR compute", this.static_device_str);
			}
				if( !this.static_geo_location_str || this.static_geo_location_str == null){
					this.static_geo_location_str =
						  "ip4=" + this.static_geo_location.IPv4
						+ "-ct=" + this.static_geo_location.city
						+ "-cc=" + this.static_geo_location.country_code
						+ "-cn=" + this.static_geo_location.country_name
						+ "-la=" + this.static_geo_location.latitude
						+ "-lo=" + this.static_geo_location.longitude
						+ "-po=" + this.static_geo_location.postal
						+ "-st=" + this.static_geo_location.state
						;
					console_log( "UserAnalytics geo_location_STR compute", this.static_geo_location_str);
				}

*/

export default UserAnalytics;
